'use strict';

/**
 * Helper: Date Format
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdDatePickerHelper for ES6 usage
 *          7.4.0 #469 Add wdDateHelper and wdDatePickerHelper
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Dallas Vogels <dvogels@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com> 
 *
 * @copyright (c) 2016-2020 Build Centrix
 */
var wdDatePickerHelper = angular.module('wd.helper.date.picker', [])
    .factory(
        'wdDatePickerHelper',
        [
            function () {
                // Initialize helper
                var helper = {};

                /**
                 * Get Date Picker Options
                 * @since 7.4.0
                 *
                 * @returns {{class: string, formatDay: string, formatYear: string, formatMonth: string, formatDayTitle: string, formatMonthTitle: string, startingDay: number, showWeeks: boolean, autoclose: boolean}}
                 */
                helper.getOptions = function () {

                    return {
                        class: 'datepicker',
                        formatDay: 'd',
                        formatYear: 'yyyy',
                        formatMonth: 'MMMM',
                        formatDayTitle: 'MMM yyyy',
                        formatMonthTitle: 'MMMM',
                        startingDay: 0,
                        showWeeks: false,
                        autoclose: true
                    };

                };

                /**
                 * Parse date picker format
                 * @since 7.4.0
                 *
                 * The bootstrap datepicker uses a different format than the environment constants offers. Thus we are
                 * reformatting the existing constant to the required format.
                 *
                 * @see https://angular-ui.github.io/bootstrap/#/datepicker
                 *
                 * @param {string} dateFormat
                 * @returns {string}
                 */
                helper.parseFormat = function (dateFormat) {
                    var result = dateFormat;

                    result = result.replace(/D/g, 'd');
                    result = result.replace(/Y/g, 'y');

                    return result;
                };


                // Return helper
                return helper;

            }
        ]
    );
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdDatePickerHelper;
}
// EOF
